import React, { useState } from 'react';
import axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useTranslation } from "react-i18next";

// const API = 'http://localhost:4000';
const API = 'https://backend-zoho.vercel.app';

export default function Contact_form_zoho2() {
  const { search } = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(search);
  const { t } = useTranslation();

  const leadId = params.get('lead_id');
  const accountId = params.get('org_id');
  const contactId = params.get('person_id');
  const hubspotContactId = params.get('hubspot_contact_id');
  const hubspotCompanyId = params.get('hubspot_company_id');


  // 💾 estados para los 7 campos
  const [lookingFor, setLookingFor] = useState('');
  const [industryType, setIndustryType] = useState('');
  const [businessSpecialty, setBusinessSpecialty] = useState('');
  const [collaboratorsCount, setCollaboratorsCount] = useState('');
  const [interestedIn, setInterestedIn] = useState([]);
  const [occupation, setOccupation] = useState('');
  const [preferredContactMethod, setPreferredContactMethod] = useState([]);

  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [responseMessage, setResponseMessage] = useState('');

  const validateStep = () => {
    const stepErrors = {};
    if (step === 1 && !lookingFor.trim()) stepErrors.lookingFor = 'Debe seleccionar una opción';
    if (step === 2 && !industryType.trim()) stepErrors.industryType = 'Debe ingresar tipo de industria';
    if (step === 3 && !businessSpecialty.trim()) stepErrors.businessSpecialty = 'Debe ingresar especialidad del negocio';
    if (step === 4 && interestedIn.length === 0) {
      stepErrors.interestedIn = 'Debe seleccionar al menos una opción';
    }
    if (step === 5 && !collaboratorsCount.trim()) stepErrors.collaboratorsCount = 'Debe ingresar cantidad de colaboradores';
    if (step === 6 && !occupation.trim()) stepErrors.occupation = 'Debe ingresar ocupación';
    if (step === 7 && preferredContactMethod.length === 0) {
      stepErrors.preferredContactMethod = 'Debe seleccionar al menos un método de contacto';
    }
    setErrors(stepErrors);
    return Object.keys(stepErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) setStep(prev => prev + 1);
  };

  const handleBack = () => setStep(prev => prev - 1);

   /**
   * 1) Actualiza en Zoho CRM
   */
   const updateZohoDetails = () => axios.put(
    `${API}/api/zoho/update-details`,
    {
      leadId,
      accountId,
      contactId,
      Estoy_Buscando1: lookingFor,
      Industry: industryType,
      Especialidad_del_negocio: businessSpecialty,
      Interesado_en: interestedIn.join(', '),
      Cantidad_de_colaboradores: collaboratorsCount,
      Ocupaci_n: occupation,
      M_todo_preferido_de_contacto: preferredContactMethod.join(', ')
    }
  );

  /**
   * 2) Actualiza contacto en HubSpot CRM
   */
  const updateHubspotContact = () => {
    if (!hubspotContactId) return Promise.resolve();
    return axios.put(`${API}/api/hubspot/update-contact`, {
      contactId: hubspotContactId,
      properties: [
        { name: 'estoy_buscando___', value: lookingFor },
        { name: 'estoy_interesado_en',   value: interestedIn.join(', ') },  // ← aquí
        { name: 'cual_es_su_ocupacion_', value: occupation},
      ]
    });
  };

  const updateHubspotCompany = () => {
    if (!hubspotCompanyId) return Promise.resolve();
    if (!industryType.trim()) {
      console.warn('⛔ industryType vacío. No se actualizará la compañía.');
      return Promise.resolve();
    }
  
    return axios.put(`${API}/api/hubspot/update-company`, {
      companyId: hubspotCompanyId,
      properties: [
        { name: 'tipo_de_industria', value: industryType },
        { name: 'cual_o_cuales_', value: businessSpecialty},
        { name: 'cantidad_de_colaboradores', value: collaboratorsCount},
      ]
    });
  };
  
  /**
   * Flujo final: Zoho -> HubSpot -> redirección
   */
  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateStep()) return;
  
    const results = [];
  
    // Zoho
    try {
      await updateZohoDetails();
      results.push({ name: 'Zoho CRM', ok: true });
    } catch (err) {
      console.error('❌ Error en Zoho:', err);
      results.push({ name: 'Zoho CRM', ok: false });
    }
  
    // HubSpot Contacto
    try {
      await updateHubspotContact();
      results.push({ name: 'HubSpot Contacto', ok: true });
    } catch (err) {
      console.error('❌ Error en Contacto HubSpot:', err);
      results.push({ name: 'HubSpot Contacto', ok: false });
    }
  
    // HubSpot Compañía
    try {
      await updateHubspotCompany();
      results.push({ name: 'HubSpot Compañía', ok: true });
    } catch (err) {
      console.error('❌ Error en Compañía HubSpot:', err);
      results.push({ name: 'HubSpot Compañía', ok: false });
    }
  

    const failures = results.filter(r => !r.ok).map(r => r.name);
    if (failures.length === 0) {
      alert('✅ Todos los datos se enviaron correctamente.');
    } else {
      alert(
        `❗ Se produjeron errores en:\n• ${failures.join('\n• ')}`
      );
    }
  
    history.push('/test-thanks-for-sending-message-zoho');
  };
  


  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <>
            <div>
              <label className="block text-2xl font-medium text-gray-700 mb-8">
              {t("titInteres")}
              </label>
              <div className="mt-1">
                <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
                  <div>
                    <input
                      type="radio"
                      name="lookingFor"
                      value="Abrir mi primer negocio"
                      id="lookingForOption1"
                      className="peer hidden"
                      checked={lookingFor === 'Abrir mi primer negocio'}
                      onChange={() => setLookingFor('Abrir mi primer negocio')}
                    />
                    <label
                      htmlFor="lookingForOption1"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/step%20one%20icons/Describe%201%20-%20Icon%281%29.svg"
                            className="w-14"
                            alt="Abrir mi primer negocio"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-[#081131] text-center">
                      {t("buscoPrimerNeg")}
                      </p>
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="lookingFor"
                      value="Abrir una nueva sucursal"
                      id="lookingForOption2"
                      className="peer hidden"
                      checked={lookingFor === 'Abrir una nueva sucursal'}
                      onChange={() => setLookingFor('Abrir una nueva sucursal')}
                    />
                    <label
                      htmlFor="lookingForOption2"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/step%20one%20icons/Describe%203%20-%20Icon.svg"
                            className="w-14"
                            alt="Abrir una nueva sucursal"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-[#081131] text-center">
                      {t("buscoNuevaSuc")}
                      </p>
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="lookingFor"
                      value="Crecer mi negocio"
                      id="lookingForOption3"
                      className="peer hidden"
                      checked={lookingFor === 'Crecer mi negocio'}
                      onChange={() => setLookingFor('Crecer mi negocio')}
                    />
                    <label
                      htmlFor="lookingForOption3"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/growth%20icon.svg"
                            className="w-14"
                            alt="Crecer mi negocio"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-[#081131] text-center">
                      {t("buscoCrecerNeg")}
                      </p>
                    </label>
                  </div>
                </div>
                <div className="flex justify-between">
                  <button
                    type="button"
                    onClick={handleBack}
                    className="w-full px-6 py-3 mt-4 mr-4 text-sm font-medium tracking-wide text-gray-700 capitalize transition-colors duration-300 transform border rounded-md focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
                  >
                    {t("buttonbackdemoconfirmed")}
                  </button>
                  <button
                    type="button"
                    onClick={handleNext}
                    className="w-full px-6 py-3 mt-4 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
                  >
                    {t("buttonnextdemoconfirmed")}
                  </button>
                </div>
              </div>
            </div>
          </>
        );
      case 2:
        return (
          <>
          <div>
            <label className="block text-2xl font-medium text-gray-700 mb-8">
            {t("titTipoInd")}
            </label>
            <div className="mt-1">
              <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
                <div>
                  <input
                    type="radio"
                    name="industryType"
                    value="Alimentos y Bebidas"
                    id="industryTypeOption1"
                    className="peer hidden"
                    checked={industryType === 'Alimentos y Bebidas'}
                    onChange={() => setIndustryType('Alimentos y Bebidas')}
                  />
                  <label htmlFor="industryTypeOption1" className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl">
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                        <img src="https://img.invupos.com/webinvu/confirmed%20demo/Alimentos%20y%20bebidas%20Icon.svg" className="w-14" alt="Alimentos y Bebidas" />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("indAlimBeb")}
                    </p>
                  </label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="industryType"
                    value="Minoristas"
                    id="industryTypeOption2"
                    className="peer hidden"
                    checked={industryType === 'Minoristas'}
                    onChange={() => setIndustryType('Minoristas')}
                  />
                  <label htmlFor="industryTypeOption2" className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl">
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                        <img src="https://img.invupos.com/webinvu/confirmed%20demo/Minoristas%20icon.svg" className="w-14" alt="Minoristas" />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("indMin")}
                    </p>
                  </label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="industryType"
                    value="Entretenimiento"
                    id="industryTypeOption3"
                    className="peer hidden"
                    checked={industryType === 'Entretenimiento'}
                    onChange={() => setIndustryType('Entretenimiento')}
                  />
                  <label htmlFor="industryTypeOption3" className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl">
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                        <img src="https://img.invupos.com/webinvu/confirmed%20demo/Entretenimiento.svg" className="w-14" alt="Entretenimiento" />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("indEnt")}
                    </p>
                  </label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="industryType"
                    value="Hospitalidad y Turismo"
                    id="industryTypeOption4"
                    className="peer hidden"
                    checked={industryType === 'Hospitalidad y Turismo'}
                    onChange={() => setIndustryType('Hospitalidad y Turismo')}
                  />
                  <label htmlFor="industryTypeOption4" className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl">
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                        <img src="https://img.invupos.com/webinvu/confirmed%20demo/Hospitalidad.svg" className="w-14" alt="Hospitalidad y Turismo" />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("indHosTur")}
                    </p>
                  </label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="industryType"
                    value="Servicios Profesionales"
                    id="industryTypeOption5"
                    className="peer hidden"
                    checked={industryType === 'Servicios Profesionales'}
                    onChange={() => setIndustryType('Servicios Profesionales')}
                  />
                  <label htmlFor="industryTypeOption5" className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl">
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                        <img src="https://img.invupos.com/webinvu/confirmed%20demo/Servicios%20profesionales.svg" className="w-14" alt="Servicios Profesionales" />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("indServProf")}
                    </p>
                  </label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="industryType"
                    value="Otros"
                    id="industryTypeOption6"
                    className="peer hidden"
                    checked={industryType === 'Otros'}
                    onChange={() => setIndustryType('Otros')}
                  />
                  <label htmlFor="industryTypeOption6" className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl">
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                        <img src="https://img.invupos.com/webinvu/confirmed%20demo/Others.svg" className="w-14" alt="Otros" />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("indOtros")}
                    </p>
                  </label>
                </div>
              </div>
              <div className="flex justify-between">
                  <button
                    type="button"
                    onClick={handleBack}
                    className="w-full px-6 py-3 mt-4 mr-4 text-sm font-medium tracking-wide text-gray-700 capitalize transition-colors duration-300 transform border rounded-md focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
                  >
                   {t("buttonbackdemoconfirmed")}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      if (industryType === 'Otros') {
                        setBusinessSpecialty('No especificado');
                        if (validateStep()) {
                          setStep(4);
                        }
                      } else {
                        if (validateStep()) {
                          setStep(3);
                        }
                      }
                    }}
                    className="w-full px-6 py-3 mt-4 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
                  >
                    {t("buttonnextdemoconfirmed")}
                  </button>
                </div>
            </div>
          </div>
        </>
        );
      case 3:
        return (
          <>
            {/* Especialidad del Negocio - TIPO DE RESTAURANTE */}
            {industryType === "Alimentos y Bebidas" && (
              <div style={{ marginBottom: "15px" }}>
                <label className="block text-2xl font-medium text-gray-700 mb-8">
                {t("titNegRest")}
                </label>
                <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyOption1"
                      name="businessSpecialty"
                      value="Alta cocina"
                      className="peer hidden"
                      checked={businessSpecialty === "Alta cocina"}
                      onChange={() => setBusinessSpecialty("Alta cocina")}
                    />
                    <label
                      htmlFor="businessSpecialtyOption1"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Alta%20cocina%281%29.svg"
                            className="w-14"
                            alt="Alta cocina"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">{t("negRestAltCoc")}</p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyOption2"
                      name="businessSpecialty"
                      value="Servicio completo informal"
                      className="peer hidden"
                      checked={businessSpecialty === "Servicio completo informal"}
                      onChange={() => setBusinessSpecialty("Servicio completo informal")}
                    />
                    <label
                      htmlFor="businessSpecialtyOption2"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Servicio%20Completo%20Informal.svg"
                            className="w-14"
                            alt="Servicio completo informal"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">{t("negRestServFullInf")}</p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyOption3"
                      name="businessSpecialty"
                      value="Servicio rápido informal"
                      className="peer hidden"
                      checked={businessSpecialty === "Servicio rápido informal"}
                      onChange={() => setBusinessSpecialty("Servicio rápido informal")}
                    />
                    <label
                      htmlFor="businessSpecialtyOption3"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Servicio%20rapido%20informal.svg"
                            className="w-14"
                            alt="Servicio rápido informal"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">{t("negRestServRapInf")}</p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyOption4"
                      name="businessSpecialty"
                      value="Un camión de comida"
                      className="peer hidden"
                      checked={businessSpecialty === "Un camión de comida"}
                      onChange={() => setBusinessSpecialty("Un camión de comida")}
                    />
                    <label
                      htmlFor="businessSpecialtyOption4"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Food%20truckk.svg"
                            className="w-14"
                            alt="Un camión de comida"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">{t("negRestCamCom")}</p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyOption5"
                      name="businessSpecialty"
                      value="Una cafetería o panadería"
                      className="peer hidden"
                      checked={businessSpecialty === "Una cafetería o panadería"}
                      onChange={() => setBusinessSpecialty("Una cafetería o panadería")}
                    />
                    <label
                      htmlFor="businessSpecialtyOption5"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Bakeryy.svg"
                            className="w-14"
                            alt="Una cafetería o panadería"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">{t("negRestCafPan")}</p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyOption6"
                      name="businessSpecialty"
                      value="Un bar o discoteca"
                      className="peer hidden"
                      checked={businessSpecialty === "Un bar o discoteca"}
                      onChange={() => setBusinessSpecialty("Un bar o discoteca")}
                    />
                    <label
                      htmlFor="businessSpecialtyOption6"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Bar%20pubs.svg"
                            className="w-14"
                            alt="Un bar o discoteca"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">{t("negRestBarDis")}</p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyOption7"
                      name="businessSpecialty"
                      value="Algo más"
                      className="peer hidden"
                      checked={businessSpecialty === "Algo más"}
                      onChange={() => setBusinessSpecialty("Algo más")}
                    />
                    <label
                      htmlFor="businessSpecialtyOption7"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Others.svg"
                            className="w-14"
                            alt="Algo más"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">{t("negRestOtro")}</p>
                    </label>
                  </div>
                </div>
              </div>
            )}

            {/* Especialidad de Negocio - TIPO DE MINORISTA */}
            {industryType === "Minoristas" && (
              <div style={{ marginBottom: "15px" }}>
                <label className="block text-2xl font-medium text-gray-700 mb-8">
                {t("titNegMin")} 
                </label>
                <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyRetail1"
                      name="businessSpecialty"
                      value="Tiendas de Conveniencia"
                      className="peer hidden"
                      checked={businessSpecialty === "Tiendas de Conveniencia"}
                      onChange={() => setBusinessSpecialty("Tiendas de Conveniencia")}
                    />
                    <label
                      htmlFor="businessSpecialtyRetail1"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Tienda%20de%20conveniencia.svg"
                            className="w-14"
                            alt="Tiendas de Conveniencia"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">
                      {t("negMinConven")}  
                      </p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyRetail2"
                      name="businessSpecialty"
                      value="Grandes Almacenes"
                      className="peer hidden"
                      checked={businessSpecialty === "Grandes Almacenes"}
                      onChange={() => setBusinessSpecialty("Grandes Almacenes")}
                    />
                    <label
                      htmlFor="businessSpecialtyRetail2"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Grandes%20almacenes.svg"
                            className="w-14"
                            alt="Grandes Almacenes"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">
                      {t("negMinGrAlm")} 
                      </p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyRetail3"
                      name="businessSpecialty"
                      value="Tiendas de Descuento"
                      className="peer hidden"
                      checked={businessSpecialty === "Tiendas de Descuento"}
                      onChange={() => setBusinessSpecialty("Tiendas de Descuento")}
                    />
                    <label
                      htmlFor="businessSpecialtyRetail3"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Tiendas%20de%20descuento.svg"
                            className="w-14"
                            alt="Tiendas de Descuento"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">
                      {t("negMinDesc")} 
                      </p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyRetail4"
                      name="businessSpecialty"
                      value="Supermercados y Tiendas de Comestibles"
                      className="peer hidden"
                      checked={businessSpecialty === "Supermercados y Tiendas de Comestibles"}
                      onChange={() => setBusinessSpecialty("Supermercados y Tiendas de Comestibles")}
                    />
                    <label
                      htmlFor="businessSpecialtyRetail4"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Supermercados.svg"
                            className="w-14"
                            alt="Supermercados y Tiendas de Comestibles"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">
                      {t("negMinSupCom")} 
                      </p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyRetail5"
                      name="businessSpecialty"
                      value="Tiendas Especializadas o de Nicho"
                      className="peer hidden"
                      checked={businessSpecialty === "Tiendas Especializadas o de Nicho"}
                      onChange={() => setBusinessSpecialty("Tiendas Especializadas o de Nicho")}
                    />
                    <label
                      htmlFor="businessSpecialtyRetail5"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Tiendas%20de%20nicho.svg"
                            className="w-14"
                            alt="Tiendas Especializadas o de Nicho"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">
                      {t("negMinNicho")}  
                      </p>
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="businessSpecialtyRetail6"
                      name="businessSpecialty"
                      value="Tiendas en Línea o E-commerce"
                      className="peer hidden"
                      checked={businessSpecialty === "Tiendas en Línea o E-commerce"}
                      onChange={() => setBusinessSpecialty("Tiendas en Línea o E-commerce")}
                    />
                    <label
                      htmlFor="businessSpecialtyRetail6"
                      className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                    >
                      <div className="flex justify-center">
                        <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                          <img
                            src="https://img.invupos.com/webinvu/confirmed%20demo/Ecommerce.svg"
                            className="w-14"
                            alt="Tiendas en Línea o E-commerce"
                          />
                        </div>
                      </div>
                      <p className="text-gray-800 text-base font-normal text-center">
                      {t("negMinEcom")} 
                      </p>
                    </label>
                  </div>
                </div>
              </div>
            )}

            {/* Especialidad de Negocio - TIPO DE ENTRETENIMIENTO */}
            {industryType === "Entretenimiento" && (
            <div style={{ marginBottom: "15px" }}>
              <label className="block text-2xl font-medium text-gray-700 mb-8">
              {t("titNegEnt")} 
              </label>
              <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
                <div>
                  <input
                    type="radio"
                    id="entertainmentOption1"
                    name="businessSpecialty"
                    value="Cine"
                    className="peer hidden"
                    checked={businessSpecialty === "Cine"}
                    onChange={() => setBusinessSpecialty("Cine")}
                  />
                  <label
                    htmlFor="entertainmentOption1"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Cine.svg"
                          className="w-14"
                          alt="Cine"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negEntCine")}   
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="entertainmentOption2"
                    name="businessSpecialty"
                    value="Parques de atracciones"
                    className="peer hidden"
                    checked={businessSpecialty === "Parques de atracciones"}
                    onChange={() => setBusinessSpecialty("Parques de atracciones")}
                  />
                  <label
                    htmlFor="entertainmentOption2"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Parque%20de%20atracciones.svg"
                          className="w-14"
                          alt="Parques de atracciones"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negEntParAtr")} 
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="entertainmentOption3"
                    name="businessSpecialty"
                    value="Clubes nocturnos"
                    className="peer hidden"
                    checked={businessSpecialty === "Clubes nocturnos"}
                    onChange={() => setBusinessSpecialty("Clubes nocturnos")}
                  />
                  <label
                    htmlFor="entertainmentOption3"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Clubes%20nocturnos.svg"
                          className="w-14"
                          alt="Clubes nocturnos"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negEntClubNoct")} 
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="entertainmentOption4"
                    name="businessSpecialty"
                    value="Teatros"
                    className="peer hidden"
                    checked={businessSpecialty === "Teatros"}
                    onChange={() => setBusinessSpecialty("Teatros")}
                  />
                  <label
                    htmlFor="entertainmentOption4"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Teatros.svg"
                          className="w-14"
                          alt="Teatros"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negEntTeat")} 
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="entertainmentOption5"
                    name="businessSpecialty"
                    value="Casinos"
                    className="peer hidden"
                    checked={businessSpecialty === "Casinos"}
                    onChange={() => setBusinessSpecialty("Casinos")}
                  />
                  <label
                    htmlFor="entertainmentOption5"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Casinos.svg"
                          className="w-14"
                          alt="Casinos"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negEntCasin")} 
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="entertainmentOption6"
                    name="businessSpecialty"
                    value="Canchas Deportivas"
                    className="peer hidden"
                    checked={businessSpecialty === "Canchas Deportivas"}
                    onChange={() => setBusinessSpecialty("Canchas Deportivas")}
                  />
                  <label
                    htmlFor="entertainmentOption6"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Canchas.svg"
                          className="w-14"
                          alt="Canchas Deportivas"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negEntDep")}  
                    </p>
                  </label>
                </div>
              </div>
            </div>
          )}


          {/* Especialidad de Negocio - TIPO DE HOSPITALIDAD Y TURISMO */}
          {industryType === "Hospitalidad y Turismo" && (
            <div style={{ marginBottom: "15px" }}>
              <label className="block text-2xl font-medium text-gray-700 mb-8">
              {t("titNegHos")}
              </label>
              <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
                <div>
                  <input
                    type="radio"
                    id="hospitalityOption1"
                    name="businessSpecialty"
                    value="Hoteles y Moteles"
                    className="peer hidden"
                    checked={businessSpecialty === "Hoteles y Moteles"}
                    onChange={() => setBusinessSpecialty("Hoteles y Moteles")}
                  />
                  <label
                    htmlFor="hospitalityOption1"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Hoteles%20y%20moteles.svg"
                          className="w-14"
                          alt="Hoteles y Moteles"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negHosHotMot")} 
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="hospitalityOption2"
                    name="businessSpecialty"
                    value="Restaurantes y Cafeterías"
                    className="peer hidden"
                    checked={businessSpecialty === "Restaurantes y Cafeterías"}
                    onChange={() => setBusinessSpecialty("Restaurantes y Cafeterías")}
                  />
                  <label
                    htmlFor="hospitalityOption2"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Restaurantes%20y%20cafeterias.svg"
                          className="w-14"
                          alt="Restaurantes y Cafeterías"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negHosRest")}
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="hospitalityOption3"
                    name="businessSpecialty"
                    value="Agencias de Viajes"
                    className="peer hidden"
                    checked={businessSpecialty === "Agencias de Viajes"}
                    onChange={() => setBusinessSpecialty("Agencias de Viajes")}
                  />
                  <label
                    htmlFor="hospitalityOption3"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Agencias%20de%20viajes.svg"
                          className="w-14"
                          alt="Agencias de Viajes"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negHosViajes")}
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="hospitalityOption4"
                    name="businessSpecialty"
                    value="Operadores de Tours"
                    className="peer hidden"
                    checked={businessSpecialty === "Operadores de Tours"}
                    onChange={() => setBusinessSpecialty("Operadores de Tours")}
                  />
                  <label
                    htmlFor="hospitalityOption4"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Operadores%20de%20tours.svg"
                          className="w-14"
                          alt="Operadores de Tours"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negHosTours")} 
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="hospitalityOption5"
                    name="businessSpecialty"
                    value="Líneas de Cruceros"
                    className="peer hidden"
                    checked={businessSpecialty === "Líneas de Cruceros"}
                    onChange={() => setBusinessSpecialty("Líneas de Cruceros")}
                  />
                  <label
                    htmlFor="hospitalityOption5"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Lineas%20de%20crucero.svg"
                          className="w-14"
                          alt="Líneas de Cruceros"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negHosCruc")}  
                    </p>
                  </label>
                </div>
              </div>
            </div>
          )}

          {/* Especialidad de Negocio - TIPO DE SERVICIOS PROFESIONALES */}
          {industryType === "Servicios Profesionales" && (
            <div style={{ marginBottom: "15px" }}>
              <label className="block text-2xl font-medium text-gray-700 mb-8">
              {t("titNegSer")}
              </label>
              <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
                <div>
                  <input
                    type="radio"
                    id="professionalServicesOption1"
                    name="businessSpecialty"
                    value="Salones de Belleza y Barberías"
                    className="peer hidden"
                    checked={businessSpecialty === "Salones de Belleza y Barberías"}
                    onChange={() => setBusinessSpecialty("Salones de Belleza y Barberías")}
                  />
                  <label
                    htmlFor="professionalServicesOption1"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Salones%20de%20belleza.svg"
                          className="w-14"
                          alt="Salones de Belleza y Barberías"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negSerSalBar")}
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="professionalServicesOption2"
                    name="businessSpecialty"
                    value="Spas"
                    className="peer hidden"
                    checked={businessSpecialty === "Spas"}
                    onChange={() => setBusinessSpecialty("Spas")}
                  />
                  <label
                    htmlFor="professionalServicesOption2"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Spas.svg"
                          className="w-14"
                          alt="Spas"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negSerSpa")} 
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="professionalServicesOption3"
                    name="businessSpecialty"
                    value="Agencias de Consultoría"
                    className="peer hidden"
                    checked={businessSpecialty === "Agencias de Consultoría"}
                    onChange={() => setBusinessSpecialty("Agencias de Consultoría")}
                  />
                  <label
                    htmlFor="professionalServicesOption3"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Agencia%20de%20consultoria.svg"
                          className="w-14"
                          alt="Agencias de Consultoría"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negSerCons")} 
                    </p>
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="professionalServicesOption4"
                    name="businessSpecialty"
                    value="Servicios Médicos Especializados"
                    className="peer hidden"
                    checked={businessSpecialty === "Servicios Médicos Especializados"}
                    onChange={() => setBusinessSpecialty("Servicios Médicos Especializados")}
                  />
                  <label
                    htmlFor="professionalServicesOption4"
                    className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                  >
                    <div className="flex justify-center">
                      <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                        <img
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Servicio%20medico.svg"
                          className="w-14"
                          alt="Servicios Médicos Especializados"
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 text-base font-normal text-center">
                    {t("negSerMed")}     
                    </p>
                  </label>
                </div>
              </div>
            </div>
          )}

          <div className="flex justify-between">
            <button
              type="button"
              onClick={handleBack}
              className="w-full px-6 py-3 mt-4 mr-4 text-sm font-medium tracking-wide text-gray-700 capitalize transition-colors duration-300 transform border rounded-md focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
            >
            {t("buttonbackdemoconfirmed")}
            </button>
            <button
              type="button"
              onClick={handleNext}
              className="w-full px-6 py-3 mt-4 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
            >
            {t("buttonnextdemoconfirmed")}
            </button>
          </div>

          </>
        );
      case 4:
        return (
          <>
          <div style={{ marginBottom: "15px" }}>
            <label className="block text-2xl font-medium text-gray-700 mb-8">
            {t("titInteres")}
            </label>
            <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
              <div>
                <input
                  type="checkbox"
                  id="interestedOption1"
                  name="interestedIn"
                  value="Recibir Pagos"
                  className="peer hidden"
                  checked={interestedIn.includes("Recibir Pagos")}
                  onChange={e => {
                    const value = e.target.value;
                    if (e.target.checked) {
                      setInterestedIn([...interestedIn, value]);
                    } else {
                      setInterestedIn(interestedIn.filter(v => v !== value));
                    }
                  }}
                />
                <label
                  htmlFor="interestedOption1"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Recibir%20pagos.svg"
                        className="w-14"
                        alt="Recibir Pagos"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("intRecPag")}
                  </p>
                </label>
              </div>
    
              <div>
                <input
                  type="checkbox"
                  id="interestedOption2"
                  name="interestedIn"
                  value="Kioscos de Autoservicio"
                  className="peer hidden"
                  checked={interestedIn.includes("Kioscos de Autoservicio")}
                  onChange={e => {
                    const value = e.target.value;
                    if (e.target.checked) {
                      setInterestedIn([...interestedIn, value]);
                    } else {
                      setInterestedIn(interestedIn.filter(v => v !== value));
                    }
                  }}
                />
                <label
                  htmlFor="interestedOption2"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Kiosko%20de%20auto%20servicio.svg"
                        className="w-14"
                        alt="Kioscos de Autoservicio"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("intKiosAuto")}
                  </p>
                </label>
              </div>
    
              <div>
                <input
                  type="checkbox"
                  id="interestedOption3"
                  name="interestedIn"
                  value="Pedidos en línea y entrega a domicilio"
                  className="peer hidden"
                  checked={interestedIn.includes("Pedidos en línea y entrega a domicilio")}
                  onChange={e => {
                    const value = e.target.value;
                    if (e.target.checked) {
                      setInterestedIn([...interestedIn, value]);
                    } else {
                      setInterestedIn(interestedIn.filter(v => v !== value));
                    }
                  }}
                />
                <label
                  htmlFor="interestedOption3"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Auto%20servicio.svg"
                        className="w-14"
                        alt="Pedidos en línea y entrega a domicilio"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("intPedEnv")} 
                  </p>
                </label>
              </div>
    
              <div>
                <input
                  type="checkbox"
                  id="interestedOption4"
                  name="interestedIn"
                  value="Marketing por correo electrónico"
                  className="peer hidden"
                  checked={interestedIn.includes("Marketing por correo electrónico")}
                  onChange={e => {
                    const value = e.target.value;
                    if (e.target.checked) {
                      setInterestedIn([...interestedIn, value]);
                    } else {
                      setInterestedIn(interestedIn.filter(v => v !== value));
                    }
                  }}
                />
                <label
                  htmlFor="interestedOption4"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Correo%20marketing.svg"
                        className="w-14"
                        alt="Marketing por correo electrónico"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("intMktMail")} 
                  </p>
                </label>
              </div>
    
              <div>
                <input
                  type="checkbox"
                  id="interestedOption5"
                  name="interestedIn"
                  value="Gestión de inventario"
                  className="peer hidden"
                  checked={interestedIn.includes("Gestión de inventario")}
                  onChange={e => {
                    const value = e.target.value;
                    if (e.target.checked) {
                      setInterestedIn([...interestedIn, value]);
                    } else {
                      setInterestedIn(interestedIn.filter(v => v !== value));
                    }
                  }}
                />
                <label
                  htmlFor="interestedOption5"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Gestion%20de%20inventario.svg"
                        className="w-14"
                        alt="Gestión de inventario"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("intGestInv")} 
                  </p>
                </label>
              </div>
    
              <div>
                <input
                  type="checkbox"
                  id="interestedOption6"
                  name="interestedIn"
                  value="Lealtad y Fidelización de Clientes"
                  className="peer hidden"
                  checked={interestedIn.includes("Lealtad y Fidelización de Clientes")}
                  onChange={e => {
                    const value = e.target.value;
                    if (e.target.checked) {
                      setInterestedIn([...interestedIn, value]);
                    } else {
                      setInterestedIn(interestedIn.filter(v => v !== value));
                    }
                  }}
                />
                <label
                  htmlFor="interestedOption6"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Lealtad.svg"
                        className="w-14"
                        alt="Lealtad y Fidelización de Clientes"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("intLealCli")} 
                  </p>
                </label>
              </div>
    
              <div>
                <input
                  type="checkbox"
                  id="interestedOption7"
                  name="interestedIn"
                  value="Algo más"
                  className="peer hidden"
                  checked={interestedIn.includes("Algo más")}
                  onChange={e => {
                    const value = e.target.value;
                    if (e.target.checked) {
                      setInterestedIn([...interestedIn, value]);
                    } else {
                      setInterestedIn(interestedIn.filter(v => v !== value));
                    }
                  }}
                />
                <label
                  htmlFor="interestedOption7"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex items-center justify-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Others.svg"
                        className="w-14"
                        alt="Algo más"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("intOtro")} 
                  </p>
                </label>
              </div>
            </div>
    
            <div className="flex justify-between">
              <button
                type="button"
                onClick={() => setStep(industryType === "Otros" ? 2 : 3)}
                className="w-full px-6 py-3 mt-4 mr-4 text-sm font-medium tracking-wide text-gray-700 capitalize transition-colors duration-300 transform border rounded-md focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
              >
              {t("buttonbackdemoconfirmed")}
              </button>
              <button
                type="button"
                onClick={handleNext}
                className="w-full px-6 py-3 mt-4 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
              >
              {t("buttonnextdemoconfirmed")}
              </button>
            </div>
          </div>
        </>
        );
      case 5:
        return (
          <>
          {/* CANTIDAD DE COLABORADORES */}
          <div style={{ marginBottom: "15px" }}>
            <label className="block text-2xl font-medium text-gray-700 mb-8">
            {t("titColab")} 
            </label>
            <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
              <div>
                <input
                  type="radio"
                  id="collaboratorsOption1"
                  name="collaboratorsCount"
                  value="Menos de 10"
                  className="peer hidden"
                  checked={collaboratorsCount === "Menos de 10"}
                  onChange={() => setCollaboratorsCount("Menos de 10")}
                />
                <label
                  htmlFor="collaboratorsOption1"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Empleados%201.svg"
                        className="w-14"
                        alt="Menos de 10"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("colMen10")} 
                  </p>
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id="collaboratorsOption2"
                  name="collaboratorsCount"
                  value="Entre 11 y 50"
                  className="peer hidden"
                  checked={collaboratorsCount === "Entre 11 y 50"}
                  onChange={() => setCollaboratorsCount("Entre 11 y 50")}
                />
                <label
                  htmlFor="collaboratorsOption2"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Empleados%202.svg"
                        className="w-14"
                        alt="Entre 11 y 50"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("col11_50")} 
                  </p>
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id="collaboratorsOption3"
                  name="collaboratorsCount"
                  value="Más de 50"
                  className="peer hidden"
                  checked={collaboratorsCount === "Más de 50"}
                  onChange={() => setCollaboratorsCount("Más de 50")}
                />
                <label
                  htmlFor="collaboratorsOption3"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Empleados%203.svg"
                        className="w-14"
                        alt="Más de 50"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("colMas50")}
                  </p>
                </label>
              </div>
            </div>
    
            <div className="flex justify-between">
              <button
                type="button"
                onClick={handleBack}
                className="w-full px-6 py-3 mt-4 mr-4 text-sm font-medium tracking-wide text-gray-700 capitalize transition-colors duration-300 transform border rounded-md focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
              >
              {t("buttonbackdemoconfirmed")}
              </button>
              <button
                type="button"
                onClick={handleNext}
                className="w-full px-6 py-3 mt-4 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
              >
              {t("buttonnextdemoconfirmed")}
              </button>
            </div>
          </div>
        </>
        );
      case 6:
        return (
          <>
          <div style={{ marginBottom: "15px" }}>
            <label className="block text-2xl font-medium text-gray-700 mb-8">
            {t("titOcupacion")}
            </label>
            <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
              <div>
                <input
                  type="radio"
                  id="occupationOption1"
                  name="occupation"
                  value="Propietario"
                  className="peer hidden"
                  checked={occupation === "Propietario"}
                  onChange={() => setOccupation("Propietario")}
                />
                <label
                  htmlFor="occupationOption1"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Propietario.svg"
                        className="w-14"
                        alt="Propietario"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("ocuProp")} 
                  </p>
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id="occupationOption2"
                  name="occupation"
                  value="Director General"
                  className="peer hidden"
                  checked={occupation === "Director General"}
                  onChange={() => setOccupation("Director General")}
                />
                <label
                  htmlFor="occupationOption2"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Director%20general.svg"
                        className="w-14"
                        alt="Director General"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("ocuDirGen")} 
                  </p>
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id="occupationOption3"
                  name="occupation"
                  value="Consultor"
                  className="peer hidden"
                  checked={occupation === "Consultor"}
                  onChange={() => setOccupation("Consultor")}
                />
                <label
                  htmlFor="occupationOption3"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Consultor.svg"
                        className="w-14"
                        alt="Consultor"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("ocuCons")} 
                  </p>
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id="occupationOption4"
                  name="occupation"
                  value="Operaciones"
                  className="peer hidden"
                  checked={occupation === "Operaciones"}
                  onChange={() => setOccupation("Operaciones")}
                />
                <label
                  htmlFor="occupationOption4"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Operaciones.svg"
                        className="w-14"
                        alt="Operaciones"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("ocuOper")}
                  </p>
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id="occupationOption5"
                  name="occupation"
                  value="IT"
                  className="peer hidden"
                  checked={occupation === "IT"}
                  onChange={() => setOccupation("IT")}
                />
                <label
                  htmlFor="occupationOption5"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/IT.svg"
                        className="w-14"
                        alt="IT"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("ocuIt")}  
                  </p>
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id="occupationOption6"
                  name="occupation"
                  value="Colaborador"
                  className="peer hidden"
                  checked={occupation === "Colaborador"}
                  onChange={() => setOccupation("Colaborador")}
                />
                <label
                  htmlFor="occupationOption6"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Colaborador.svg"
                        className="w-14"
                        alt="Colaborador"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("ocuColl")} 
                  </p>
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id="occupationOption7"
                  name="occupation"
                  value="Otra"
                  className="peer hidden"
                  checked={occupation === "Otra"}
                  onChange={() => setOccupation("Otra")}
                />
                <label
                  htmlFor="occupationOption7"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Others.svg"
                        className="w-14"
                        alt="Otra"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("ocuOtra")} 
                  </p>
                </label>
              </div>
            </div>
    
            <div className="flex justify-between">
              <button
                type="button"
                onClick={handleBack}
                className="w-full px-6 py-3 mt-4 mr-4 text-sm font-medium tracking-wide text-gray-700 capitalize transition-colors duration-300 transform border rounded-md focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
              >
              {t("buttonbackdemoconfirmed")}
              </button>
              <button
                type="button"
                onClick={handleNext}
                className="w-full px-6 py-3 mt-4 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
              >
              {t("buttonnextdemoconfirmed")}
              </button>
            </div>
          </div>
        </>
        );
      case 7:
        return (
          <form onSubmit={handleSubmit}>
             <div style={{ marginBottom: "15px" }}>
            <label className="block text-2xl font-medium text-gray-700 mb-8">
            {t("titContacto")}
            </label>
            <div className="grid lg:grid-cols-3 grid-cols-2 gap-4 mb-6">
              {/* Opción 1 */}
              <div>
                <input
                  type="checkbox"
                  id="contactOption1"
                  name="preferredContactMethod"
                  value="Llamada Telefónica"
                  className="peer hidden"
                  checked={preferredContactMethod.includes("Llamada Telefónica")}
                  onChange={(e) => {
                    const val = e.target.value;
                    setPreferredContactMethod(prev =>
                      e.target.checked
                        ? [...prev, val]
                        : prev.filter(v => v !== val)
                    );
                  }}
                />
                <label
                  htmlFor="contactOption1"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Telephone.svg"
                        className="w-14"
                        alt="Llamada Telefónica"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("contTel")}  
                  </p>
                </label>
              </div>

              {/* Opción 2 */}
              <div>
                <input
                  type="checkbox"
                  id="contactOption2"
                  name="preferredContactMethod"
                  value="WhatsApp"
                  className="peer hidden"
                  checked={preferredContactMethod.includes("WhatsApp")}
                  onChange={(e) => {
                    const val = e.target.value;
                    setPreferredContactMethod(prev =>
                      e.target.checked
                        ? [...prev, val]
                        : prev.filter(v => v !== val)
                    );
                  }}
                />
                <label
                  htmlFor="contactOption2"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/WhatsApp.svg"
                        className="w-14"
                        alt="WhatsApp"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("contWa")} 
                  </p>
                </label>
              </div>

              {/* Opción 3 */}
              <div>
                <input
                  type="checkbox"
                  id="contactOption3"
                  name="preferredContactMethod"
                  value="Correo Electrónico"
                  className="peer hidden"
                  checked={preferredContactMethod.includes("Correo Electrónico")}
                  onChange={(e) => {
                    const val = e.target.value;
                    setPreferredContactMethod(prev =>
                      e.target.checked
                        ? [...prev, val]
                        : prev.filter(v => v !== val)
                    );
                  }}
                />
                <label
                  htmlFor="contactOption3"
                  className="block h-56 cursor-pointer rounded-lg border border-gray-100 bg-white p-7 text-sm font-medium shadow-sm hover:border-gray-200 peer-checked:border-blue-500 peer-checked:ring-1 peer-checked:ring-blue-500 hover:scale-105 transform transition hover:shadow-xl"
                >
                  <div className="flex justify-center">
                    <div className="w-20 mb-5 h-20 rounded-full flex justify-center items-center bg-sky-50">
                      <img
                        src="https://img.invupos.com/webinvu/confirmed%20demo/Email.svg"
                        className="w-14"
                        alt="Correo Electrónico"
                      />
                    </div>
                  </div>
                  <p className="text-gray-800 text-base font-normal text-center">
                  {t("contMail")} 
                  </p>
                </label>
              </div>
            </div>

            <div className="flex justify-between">
              <button
                type="button"
                onClick={handleBack}
                className="w-full px-6 py-3 mt-4 mr-4 text-sm font-medium tracking-wide text-gray-700 capitalize transition-colors duration-300 transform border rounded-md focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
              >
              {t("buttonbackdemoconfirmed")}
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                className="w-full px-6 py-3 mt-4 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-green-500 rounded-md hover:bg-green-400 focus:outline-none focus:ring focus:ring-green-300 focus:ring-opacity-50"
              >
              {t("buttonnextdemoconfirmed")}
              </button>
            </div>
          </div>
          </form>
        );
      default:
        return null;
    }
  };

  return (
    <>
          <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
            {/* <h1>Crear Organización, Contacto y Lead en Pipedrive</h1> */}
            {renderStep()}
            {responseMessage && (
              <p style={{ marginTop: '20px', color: responseMessage.includes('Error') ? 'red' : 'green' }}>
                {responseMessage}
              </p>
            )}
          </div>
            <div
            class="relative z-50"
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"
          >
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
    
            <div class="fixed inset-0 z-10 overflow-y-auto">
              <section class="min-h-screen  bg-white lg:flex">
                <div class="flex flex-col justify-end px-8 bg-gradient-to-b from-pirLightBlue to-pirPurple lg:px-12 xl:px-24 lg:w-1/2">
                  <div className="hidden lg:block">
                    <div>
                    {/* <p>HubSpot ID contact: {hubspotContactId} y ID company: {hubspotCompanyId}</p> */}
                      <p className="inline-block px-3 py-1 mb-3 text-xs  mx-auto font-bold tracking-wider uppercase rounded-full bg-#2A72FF border-white border">
                        <span className="text-white">Invu POS</span>
                      </p>
                      <h2 className="mb-4 font-sans text-3xl font-bold tracking-tight text-white sm:text-[43px] sm:leading-none">
                      {t("titledemoconfirmed")}
                      </h2>
                      <p className="pr-5 mb-2 text-md text-white opacity-90">
                      {t("descriptiondemoconfirmed")}{" "}
                        <span className="font-semibold italic">
                        {t("descriptiondemoconfirmedspan")}
                        </span>
                      </p>
                    </div>
    
                    <Carousel
                      className="z-10 relative ss"
                      autoPlay={true}
                      showThumbs={false}
                      showArrows={false}
                      infiniteLoop={true}
                      interval={6000}
                      swipeable={false}
                      showStatus={false}
                      showIndicators={false}
                      swipeAnimationHandler={false}
                      animationHandler="fade"
                      handleTransition="fade"
                    >
                      <div>
                        <img
                          className="self-end "
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Hero-confirmed-1.webp"
                          alt="Ecommerce Hero"
                          loading="lazy"
                          style={{ width: "540px", height: "auto" }}
                        />
                      </div>
                      <div>
                        <img
                          className="self-end "
                          src="https://img.invupos.com/webinvu/confirmed%20demo/Hero%20confirmed%204.png"
                          alt="Ecommerce Hero"
                          loading="lazy"
                          style={{ width: "540px", height: "auto" }}
                        />
                      </div>
                    </Carousel>
                  </div>
                </div>
    
                <div class="flex flex-col justify-center w-full p-5 pt-0 lg:w-1/2 lg:px-12 xl:px-12 bg-[url('https://img.invupos.com/webinvu/confirmed%20demo/step%20one%20icons/Bg-abstract-form%281%29.png')]">
                  <div className="mb-14 mt-10 lg:mt-0 ">
                    <img
                      className="h-[65px] w-auto"
                      src="https://res.cloudinary.com/dslkvd23s/image/upload/v1648001932/Branding%20Invu%20/Logo%20Invu/logo-INVU-POS-rgb_nrg6ry.png"
                      alt=""
                    />
                  </div>
                  

                    {renderStep()}
                    {responseMessage && (
                      <div className="max-w-lg bg-white border border-gray-200 rounded-xl shadow-lg" role="alert" tabIndex="-1" aria-labelledby="toast-message">
                        <div className="flex p-4">
                          <div className="shrink-0 mr-2">
                            {responseMessage.includes('Error') ? (
                              <svg className="shrink-0 size-4 text-red-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                              </svg>
                            ) : (
                              <svg className="shrink-0 size-4 text-teal-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                              </svg>
                            )}
                          </div>
                          <div className="ms-3">
                            <p id="toast-message" className="text-sm text-gray-700 dark:text-neutral-400">
                              {responseMessage}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    {Object.keys(errors).length > 0 && (
                      <div className="mt-4 text-red-500 text-sm">
                        {Object.values(errors).map((error, index) => (
                          <p key={index}>{error}</p>
                        ))}
                      </div>
                    )}
                </div>
              </section>
            </div>
          </div>
    </>
  );
};

